module.exports = __webpack_public_path__ + "pc/img/swiper_bg_06.59239254.jpg";